import {SfOAuth2Service} from '../../libs/ui/src/index';

import {client} from '../apiService';
const _SfOAuth2Service = new SfOAuth2Service({client});
export {_SfOAuth2Service as SfOAuth2Service};
